{
  "fr": {
    "reminder": {
      "actions": {
        "cancel": "Annuler",
        "edit": "Modifier",
        "hideReminders": "Masquez les rappels",
        "save": "Enregistrer",
        "showReminders": "Montrer les rappels"
      },
      "contactType": {
        "customer": "Client",
        "partner": "Partner"
      },
      "labels": {
        "after": "après",
        "before": "avant",
        "click": "Cliquez ici pour définir le rappel",
        "date": "sur {date}",
        "dateAfterDueDate": "Après la date limite",
        "dateAlreadyPassed": "la date est déjà passée",
        "decisionApprovedNotSent": "La décision a été prise. Les rappels qui étaient toujours en attente sont annulés.",
        "dueDate": "la date limite",
        "editTitle": "Modifier les rappels",
        "here": "ici",
        "infoReminders": "Les rappels ne sont actifs que pour les versements dont l'échéance est fixée.",
        "noReminderSet": "Aucun rappel défini",
        "reminder": "Rappel",
        "reminders": "Rappels",
        "remindersCustomer": "Rappels pour le client",
        "remindersPartners": "Rappels pour les partenaires",
        "reminders_count": "{count} rappel défini | {count} rappels définis",
        "sendOnDeadline": "Rappel sera envoyé à la date limite prévue",
        "sendReminder": "Envoyer rappel",
        "sent_at": "Rappel envoyé le {date}",
        "warningReminders": "Cette action remplace les 4 rappels. Tout rappel laissé vide ici sera supprimé pour chaque décision."
      },
      "toasts": {
        "update": "Rappel mis à jour avec succès"
      }
    }
  }
}
